export class Employee {
    employeeId: number | null = null;
    employeeName: string = '';
    email: string = '';
    workStateId : number | null = null;
    companyId: number | null = null;
    isActive: boolean | null = null;
}